import React from 'react';
import { formatCurrency } from '../../utils/invoiceUtils';

const InvoiceKpiCards = ({ kpis, onClickVencido }) => {
  if (!kpis) return null;
  const ivaNote = (totalConIva) => (
    <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>
      ({formatCurrency(totalConIva)} con IVA)
    </div>
  );
  // Segunda nota: importe alternativo (base imponible) con su etiqueta.
  const baseNote = (label, base) => (
    <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>
      {label} {formatCurrency(base)} sin IVA
    </div>
  );
  return (
    <div className="row g-2 mb-3">
      <div className="col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-muted small">Facturado este mes</div>
            <div className="h4 mb-0">{formatCurrency(kpis.facturado_mes_base)}</div>
            {ivaNote(kpis.facturado_mes)}
            {baseNote('Total borradores inc.', kpis.facturado_mes_base_borradores)}
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-muted small">Cobrado este mes</div>
            <div className="h4 mb-0 text-success">{formatCurrency(kpis.cobrado_mes_base)}</div>
            {ivaNote(kpis.cobrado_mes)}
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-muted small">Pendiente este mes</div>
            <div className="h4 mb-0 text-warning">{formatCurrency(kpis.pendiente_mes_base)}</div>
            {ivaNote(kpis.pendiente_mes)}
            {baseNote('Pendiente total', kpis.pendiente_total_base)}
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div
          className="card shadow-sm h-100"
          role={onClickVencido ? 'button' : undefined}
          onClick={onClickVencido}
        >
          <div className="card-body">
            <div className="text-muted small">
              Vencido este mes {Number(kpis.vencido_mes_count || 0) > 0 && `(${kpis.vencido_mes_count})`}
            </div>
            <div className="h4 mb-0 text-danger">{formatCurrency(kpis.vencido_mes_base)}</div>
            {ivaNote(kpis.vencido_mes)}
            {baseNote('Vencido total', kpis.vencido_total_base)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceKpiCards;
